
const problems = [
  { icon: 'ri-close-circle-line', text: 'No clear call-to-action' },
  { icon: 'ri-smartphone-line', text: 'Hard to book on mobile' },
  { icon: 'ri-speed-line', text: 'Slow load times' },
  { icon: 'ri-file-list-line', text: 'No lead capture' },
  { icon: 'ri-bar-chart-line', text: 'No tracking' },
  { icon: 'ri-search-line', text: 'Not optimized for local search' }
];

export default function Problem() {
  return (
    <section className="py-24 px-6 bg-[#0A0A0A] relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-red-500/5 to-transparent"></div>
      
      <div className="max-w-5xl mx-auto relative z-10">
        <h2 className="text-4xl md:text-5xl font-black text-center mb-16">
          Most Service Business Websites Are <span className="text-red-400">Costing You Jobs.</span>
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {problems.map((problem, index) => (
            <div 
              key={index}
              className="bg-[#151515] border border-red-500/30 rounded-xl p-6 hover:border-red-500/50 transition-all"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-red-500/10 rounded-lg mb-4">
                <i className={`${problem.icon} text-2xl text-red-400`}></i>
              </div>
              <p className="text-lg font-bold text-gray-200">{problem.text}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-2xl md:text-3xl font-black text-[#3B82F6] border-t-4 border-b-4 border-[#3B82F6] py-6 inline-block px-8">
            If it doesn't convert, it doesn't matter.
          </p>
        </div>
      </div>
    </section>
  );
}
